import Modal from '../Modal';
import TextInput from '../TextInput';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { setFormDetailsQuery } from '../../lib/Queries';
import { useEffect, useState } from 'react';
import Toggle from '../Toggle.jsx';

const RenameFormModal = ({ isOpen, onClose, form }) => {
	const { save, isSaving } = useBusinessPostApi(`/forms/${form?.id}`);
	const styles = form?.settings?.styles;

	const [name, setName] = useState(form?.name);
	const [hideFormName, setHideFormName] = useState(!!styles?.hideFormName);
	const [hideSubmit, setHideSubmit] = useState(!!styles?.hideSubmit);
	const [embedOnly, setEmbedOnly] = useState(!!styles?.embedOnly);
	const [embedOnlyRedirectUrl, setEmbedOnlyRedirectUrl] = useState(
		styles?.embedOnlyRedirectUrl || '',
	);

	useEffect(() => {
		setName(form?.name);
		setHideFormName(!!styles?.hideFormName);
		setHideSubmit(!!styles?.hideSubmit);
		setEmbedOnly(!!styles?.embedOnly);
		setEmbedOnlyRedirectUrl(styles?.embedOnlyRedirectUrl || '');
	}, [
		form?.name,
		isOpen,
		styles?.hideFormName,
		styles?.hideSubmit,
		styles?.embedOnly,
		styles?.embedOnlyRedirectUrl,
	]);

	function submit(ev) {
		ev.preventDefault();

		save({
			name,
			hideFormName,
			hideSubmit,
			embedOnly,
			embedOnlyRedirectUrl,
		}).then(result => {
			setFormDetailsQuery(form.id, result);
			onClose();
		});
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<form onSubmit={submit}>
				<h2 className="text-2xl font-semibold text-center mb-6">
					Form Settings
				</h2>

				<TextInput
					id="name"
					value={name}
					onChange={setName}
					label="Form Name"
					autoFocus={isOpen}
					required={true}
				/>

				<div className="flex items-center mt-4 ml-3">
					<div className="mr-4">Show form name to clients</div>
					<Toggle
						enabled={!hideFormName}
						setEnabled={newValue => setHideFormName(!newValue)}
					/>
				</div>

				<div className="mt-6">
					<div className="panel-label">Options</div>
					<div className="panel max-w-none pl-4">
						<div className="flex items-center justify-between py-3 pr-4">
							<div className="mr-4">
								Hide Submit button
								<div className="text-gray-500 text-sm">
									Clients can view the form, but not submit it
								</div>
							</div>
							<Toggle
								enabled={hideSubmit}
								setEnabled={setHideSubmit}
								label="Hide Submit button"
							/>
						</div>
						<div className="py-3 pr-4 border-t">
							<div className="flex items-center justify-between">
								<div className="mr-4">
									Only allow access when embedded
									<div className="text-gray-500 text-sm">
										Prevent direct access to the form URL
									</div>
								</div>
								<Toggle enabled={embedOnly} setEnabled={setEmbedOnly} />
							</div>

							{embedOnly && (
								<div className="mt-3">
									<TextInput
										label="Redirect URL"
										placeholder="https://example.com"
										autoFocus={!embedOnlyRedirectUrl}
										value={embedOnlyRedirectUrl}
										onChange={setEmbedOnlyRedirectUrl}
									/>
									<div className="text-gray-500 text-xs mt-1 ml-3">
										Users will be redirected here if they try to
										access the form directly
									</div>
								</div>
							)}
						</div>
					</div>
				</div>

				<button className="btn-save mt-6">
					{isSaving ? 'Saving...' : 'Save Changes'}
				</button>
			</form>
		</Modal>
	);
};

export default RenameFormModal;
